import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  margin: 0;
  font-family: ${font_family_weight_regular};
  ${font_md};
  color: ${text_colorTextSecondary};

  .PhysicalCardLifecycleModal-status {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
  }

  p {
    margin: 0;
  }
`
